import { render, staticRenderFns } from "./TheoDoiTinhTrangPhong.vue?vue&type=template&id=ddac040a&scoped=true"
import script from "./TheoDoiTinhTrangPhong.vue?vue&type=script&lang=js"
export * from "./TheoDoiTinhTrangPhong.vue?vue&type=script&lang=js"
import style0 from "./TheoDoiTinhTrangPhong.vue?vue&type=style&index=0&id=ddac040a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac040a",
  null
  
)

export default component.exports